import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const DefaultLayout = () => import('@/layouts/DefaultLayout')
const LoginPage = () => import('@/pages/LoginPage')
const NotFoundPage = () => import('@/pages/NotFoundPage')
const PlateListPage = () => import('@/pages/plate/PlateListPage')
const NeedsModerationListPage = () => import('@/pages/plate/NeedsModerationListPage')
const CameraListPage = () => import('@/pages/camera/CameraListPage')
const CameraAddEditPage = () => import('@/pages/camera/CameraAddEditPage')
const HistoryListPage = () => import('@/pages/history/HistoryListPage')
const TelegramChatListPage = () => import('@/pages/telegram/TelegramChatListPage')
const MemberListPage = () => import('@/pages/member/MemberListPage')
const MemberAddEditPage = () => import('@/pages/member/MemberAddEditPage')
const DashboardPage = () => import('@/pages/dashboard/DashboardPage')
const QRCodeListPage = () => import('@/pages/print/QRCodeListPage')
const QRCodeEditPage = () => import('@/pages/print/QRCodeEditPage')
const QRCodeGeneratePage = () => import('@/pages/print/QRCodeGeneratePage')
const OrganizationSummaryPage = () => import('@/pages/organization/OrganizationSummaryPage')
const MeasurementListPage = () => import('@/pages/measurement/MeasurementListPage')
const MeasurementAddEditPage = () => import('@/pages/measurement/MeasurementAddEditPage')
const ProductListPage = () => import('@/pages/product/ProductListPage')
const ProductAddEditPage = () => import('@/pages/product/ProductAddEditPage')
const CustomerListPage = () => import('@/pages/customer/CustomerListPage')
const CustomerAddEditPage = () => import('@/pages/customer/CustomerAddEditPage')
const InvoiceListPage = () => import('@/pages/document/InvoiceListPage')
const InvoiceAddEditPage = () => import('@/pages/document/InvoiceAddEditPage')
const OrganizationListPage = () => import('@/pages/organization/OrganizationListPage')
const OrganizationAddEditPage = () => import('@/pages/organization/OrganizationAddEditPage')
const QrCodeScannedHistory = () => import('@/pages/print/QrCodeScannedHistory')
const GroupListPage = () => import('@/pages/organization-group/GroupListPage')
const GroupAddEditPage = () => import('@/pages/organization-group/GroupAddEditPage')
const SettingsPage = () => import('@/pages/settings/Settings')
const ExportLogListPage = () => import('@/pages/export/ExportLogListPage')
const TaxReportsListPage = () => import('@/pages/reports/TaxReportToTheTaxOffice')
const FeatureReportsListPage = () => import('@/pages/reports/FeatureReportsListPage')
const PlateDataListPage = () => import('@/pages/gai-data/PlateDataListPage')
const AddEditPlateDataPage = () => import('@/pages/gai-data/AddEditPlateDataPage')
const PlateMonitoringPage = () => import('@/pages/reports/PlateMonitoringPage')

Vue.use(Router)

function beforeEnter (to, from, next) {
  if (!store.getters.currentToken) {
    next('/login')
  } else {
    if ((to.name === 'OrganizationList' ||
      to.name === 'Dashboard page' ||
      to.name === 'HistoryList' ||
      to.name === 'TelegramChatList' ||
      to.name === 'GroupList'
    ) && (store.getters.getUser && !store.getters.isSuperAdmin)) {
      next(false)
    } else if (store.getters.isTaxInspector && to.name !== 'Plate list') {
      next(false)
    } else {
      next()
    }
  }
}

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: to => {
        if (store.getters.isOperator || store.getters.isScanner) {
          return '/qr-code'
        } else {
          return '/plate'
        }
      },
      name: 'Home',
      component: DefaultLayout,
      beforeEnter: beforeEnter,
      children: [
        {
          path: 'qr-generate',
          name: 'QrGenerate',
          redirect: '/qr-generate/view',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'view',
              name: 'QrGenerateView',
              component: QRCodeGeneratePage
            }
          ]
        },
        {
          path: 'qr-code',
          name: 'qrCode',
          redirect: '/qr-code/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'QR Code list',
              component: QRCodeListPage
            },
            {
              path: 'edit/:id',
              name: 'QRCodeEdit',
              component: QRCodeEditPage
            }
          ]
        },
        {
          path: 'scanned-history',
          name: 'QR Kodni tekshirish',
          redirect: '/scanned-history/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'QrCodeScannedHistory',
              component: QrCodeScannedHistory
            }
          ]
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          redirect: 'dashboard/widgets',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'widgets',
              name: 'Dashboard page',
              component: DashboardPage
            }
          ]
        },
        {
          path: 'needs-moderation',
          name: 'NeedsModeration',
          redirect: '/needs-moderation/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'NeedsModerationList',
              component: NeedsModerationListPage
            }
          ]
        },
        {
          path: 'plate',
          name: 'Avto Raqam',
          redirect: '/plate/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'Plate list',
              component: PlateListPage
            }
          ]
        },
        {
          path: 'camera',
          name: 'Camera',
          redirect: '/camera/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'Cameras',
              component: CameraListPage
            },
            {
              path: 'add',
              name: 'CameraAdd',
              component: CameraAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'CameraEdit',
              component: CameraAddEditPage
            }
          ]
        },
        {
          path: 'history',
          name: 'History',
          redirect: '/history/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'HistoryList',
              component: HistoryListPage
            }
          ]
        },
        {
          path: 'telegram-chat',
          name: 'TelegramChat',
          redirect: '/telegram-chat/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'TelegramChatList',
              component: TelegramChatListPage
            }
          ]
        },
        {
          path: 'member',
          name: 'MemberChat',
          redirect: '/member/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'MemberList',
              component: MemberListPage
            },
            {
              path: 'add',
              name: 'MemberAdd',
              component: MemberAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'MemberEdit',
              component: MemberAddEditPage
            }
          ]
        },
        {
          path: 'customer',
          name: 'Oluvchi',
          redirect: '/customer/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'CustomerList',
              component: CustomerListPage
            },
            {
              path: 'add',
              name: 'CustomerAdd',
              component: CustomerAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'CustomerEdit',
              component: CustomerAddEditPage
            }
          ]
        },
        {
          path: 'organization-group',
          name: 'Organization Groups',
          redirect: '/organization-group/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'GroupList',
              component: GroupListPage
            },
            {
              path: 'add',
              name: 'GroupAdd',
              component: GroupAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'GroupEdit',
              component: GroupAddEditPage
            }
          ]
        },
        {
          path: 'organization',
          name: 'Korxona',
          redirect: '/organization/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'OrganizationList',
              component: OrganizationListPage
            },
            {
              path: 'add',
              name: 'OrganizationAdd',
              component: OrganizationAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'OrganizationEdit',
              component: OrganizationAddEditPage
            },
            {
              path: 'summary/:id/:type',
              name: 'OrganizationSummary',
              component: OrganizationSummaryPage
            }
          ]
        },
        {
          path: 'document',
          name: 'Hujjatlar',
          redirect: '/document/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'InvoiceList',
              component: InvoiceListPage
            },
            {
              path: 'add',
              name: 'InvoiceAdd',
              component: InvoiceAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'InvoiceEdit',
              component: InvoiceAddEditPage
            }
          ]
        },
        {
          path: 'measurement',
          name: 'Measurement',
          redirect: '/measurement/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'MeasurementList',
              component: MeasurementListPage
            },
            {
              path: 'add',
              name: 'MeasurementAdd',
              component: MeasurementAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'MeasurementEdit',
              component: MeasurementAddEditPage
            }
          ]
        },
        {
          path: 'product',
          name: 'Maxsulot turi',
          redirect: '/product/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'ProductListPage',
              component: ProductListPage
            },
            {
              path: 'add',
              name: 'ProductAddPage',
              component: ProductAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'ProductEditPage',
              component: ProductAddEditPage
            }
          ]
        },
        {
          path: 'settings',
          name: 'Settings',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'SettingsPage',
              component: SettingsPage
            }
          ]
        },
        {
          path: 'export-log',
          name: 'Export Log',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'ExportLogListPage',
              component: ExportLogListPage
            }
          ]
        },
        {
          path: '/gai-data',
          name: 'GAI Data',
          redirect: '/gai-data/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'PlateDataListPage',
              component: PlateDataListPage
            },
            {
              path: 'add',
              name: 'AddPlateDataPage',
              component: AddEditPlateDataPage
            },
            {
              path: 'edit/:id',
              name: 'EditPlateDataPage',
              component: AddEditPlateDataPage
            }
          ]
        },
        {
          path: 'tax-reports',
          name: 'Tax Reports',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'TaxReportsListPage',
              component: TaxReportsListPage
            }
          ]
        },
        {
          path: 'feature-reports',
          name: 'Feature Reports',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'FeatureReportsListPage',
              component: FeatureReportsListPage
            }
          ]
        },
        {
          path: 'plate-monitoring',
          name: 'Plate Monitoring',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'PlateMonitoringPage',
              component: PlateMonitoringPage
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFoundPage
    },
    {
      path: '*',
      component: NotFoundPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js